import { render, staticRenderFns } from "./MergePersonSsnModal.vue?vue&type=template&id=1109372c&scoped=true&"
import script from "./MergePersonSsnModal.vue?vue&type=script&lang=ts&"
export * from "./MergePersonSsnModal.vue?vue&type=script&lang=ts&"
import style0 from "./MergePersonSsnModal.vue?vue&type=style&index=0&id=1109372c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1109372c",
  null
  
)

export default component.exports